    import React, { useEffect, useRef, useState } from 'react'
    import carsTable from './cars';
    import styles from './GioCaoDiem.module.css';
    import { Car } from './Car';
    export const GRID_SIZE = 6;
    export const TOTAL_CELL = GRID_SIZE * GRID_SIZE;


    export const GioCaoDiem = () => {
        const [curTableIndex, setCurTableIndex] = useState(0);
        const [curTable, setCurTable] = useState(carsTable[curTableIndex]);
        const [resetKey, setResetKey] = useState(0);
        const [lock, setLock] = useState(false);
        const titleRef = useRef(null);
        const [isVisible, setIsVisible] = useState(true);
        const [step, setStep] = useState(0);
        const [gridSize, setGridSize] = useState({width: 0, height: 0});
        const gridRef = useRef(null);

        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';

        useEffect( () => {
            const handleResize = () => {
                if(gridRef.current) {
                    const {width, height} = gridRef.current.getBoundingClientRect();
                    setGridSize({width, height});
                    setResetKey(prev => prev + 1)
                }
            }
            
            window.addEventListener("resize", handleResize);
            handleResize();

            return () => window.removeEventListener('resize', handleResize)
        }, [])

        useEffect( () => {
            if(step > curTable[0].step) lose();
        }, [step])

        const handleReset = () => {
            const resetTable = carsTable[curTableIndex].map(car => ({...car}));
            setCurTable(resetTable);
            setResetKey(prev => prev + 1);
            setLock(false);
            setStep(0);
            titleRef.current.innerHTML = 'Giờ Cao Điểm';
        }
        const win = () => {
            setLock(true);
            titleRef.current.innerHTML = "Congratulations! You Won"
        }
        const lose = () => {
            setLock(true);
            titleRef.current.innerHTML = "Congratulations! You LOSE"
        }

        const handleContainerClick = (e) => {
            setIsVisible(true);
            e.stopPropagation();
        }
        const handleControlClick = (e) => {
            e.stopPropagation()
            setIsVisible(false);
        }
        const handleRoundClick = (e, index) => {
            e.stopPropagation();
            setCurTableIndex(index);
            setCurTable(carsTable[index])
            setResetKey(prev => prev + 1);
            setLock(false);
            setStep(0);
            setIsVisible(true);
            titleRef.current.innerHTML = 'Giờ Cao Điểm';
        }

        return (
            <div 
                className={styles.container}
                onClick={handleContainerClick}
                onMouseMove={(e) => {e.preventDefault()}}
                onTouchMove={(e) => e.preventDefault()}
            >
                <div className={styles.bocuc}>
                    <h1 className={styles.title} ref={titleRef}>Giờ Cao Điểm</h1>
                    <div className={styles.introduction}>
                       <span className={styles['title-intro']}>Cách chơi :</span>
                       <p>Tìm cách để ô vuông màu đỏ thoát ra khỏi bảng. Mỗi lần di chuyển tiến hoặc lùi 1 ô thì tính là 1 bước di chuyển.</p>
                    </div>
                    <p className={styles['step-count']}>Total Step: {step}/{curTable[0].step}</p>
                    <div>
                        {!isVisible &&
                            <div className={styles.board} onClick={(e) => e.stopPropagation()}>
                                <div className={styles['control-title']} style={{color: '#0A2A66'}}>
                                    CHỌN THỬ THÁCH
                                </div>
                                <div style={{display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gridTemplateRows: 'repeat(2, 1fr)'}}>
                                    {carsTable.map((_, i) => (
                                        <button 
                                            key={i} 
                                            className={`${styles.round} ${i === curTableIndex ? styles['round-border'] : ''}`} 
                                            onClick={(e) => handleRoundClick(e, i)}
                                        >
                                            {i + 1}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        }
                    </div>
                    
                    <div 
                        className={styles.gameContent} 
                        ref={gridRef} 
                        style={{gridTemplateColumns: `repeat(${GRID_SIZE}, 1fr)`, gridTemplateRows: `repeat(${GRID_SIZE}, 1fr)`}}
                    >
                        {Array.from({ length: TOTAL_CELL }, (_,i) => {
                            const curRow = Math.floor(i/GRID_SIZE) + 1
                            const curCol = i % GRID_SIZE + 1;
                            let curExit = -1;
                            const exitEdge = curTable[0].exit_edge;
                            if(exitEdge === 'exit-top' && curRow === 1) curExit = curCol;
                            if(exitEdge === 'exit-bottom' && curRow === GRID_SIZE) curExit = curCol;
                            if(exitEdge === 'exit-left' && curCol === 1) curExit = curRow;
                            if(exitEdge === 'exit-right' && curCol === GRID_SIZE) curExit = curRow;
                            return <div
                                        key={i}
                                        className={`${styles['grid-item']} ${curExit === curTable[0].exit ? styles[curTable[0].exit_edge] : ''}`}
                                    ></div>
                        })}
        
                        {curTable.map((car) => (
                            <Car key={`${car.id}-${resetKey}`} car={car} cars={curTable} lock={lock} win={win} setStep={setStep} gridSize={gridSize}/>
                        ))}
                    </div>
                    <div style={{display: 'flex', justifyContent: 'center', gap: "20px"}}>
                        <button className={styles.reset} onClick={handleReset}>
                            CHƠI LẠI
                        </button>
                        {isVisible && (
                            <button className={styles.reset} onClick={handleControlClick}>
                                CHỌN MÀN
                            </button>
                        )}
                    </div>
                </div>
            </div>
        );        
    }
